module.exports = __webpack_public_path__ + "img/programme_icon_shequpintuan.ba8d2908.png";